<div class="carrousel-app">
    <div class="content-app">
        <div class="row mx-0">
            <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 px-0">
                <div id="carouselRedLaboral" class="carousel slide carousel-custom" data-bs-ride="carousel">
                    <!-- Loading indicator -->
                    <div *ngIf="loading" class="text-center p-5">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando...</span>
                        </div>
                    </div>
                    
                    <!-- Dynamic carousel indicators -->
                    <div class="carousel-indicators">
                        <ng-container *ngFor="let item of carouselItems; let i = index">
                            <button type="button" 
                                    data-bs-target="#carouselRedLaboral" 
                                    [attr.data-bs-slide-to]="i" 
                                    [class.active]="i === 0"
                                    [attr.aria-current]="i === 0 ? 'true' : null"
                                    [attr.aria-label]="'Slide ' + (i + 1)">
                            </button>
                        </ng-container>
                    </div>
                    
                    <!-- Dynamic carousel items -->
                    <div class="carousel-inner">
                        <ng-container *ngFor="let item of carouselItems; let i = index">
                            <div class="carousel-item" [class.active]="i === 0">
                                <div class="carousel-image-container">
                                    <img [src]="item.imageUrl" class="carousel-image" alt="RedLaboralRD" />
                                    <!-- Opcional: Mostrar título/descripción del carrusel -->
                                    <div *ngIf="item.title || item.description" class="carousel-caption d-none d-md-block">
                                        <h4 *ngIf="item.title">{{ item.title }}</h4>
                                        <p *ngIf="item.description">{{ item.description }}</p>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    
                    <!-- Controles de navegación -->
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselRedLaboral" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Anterior</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselRedLaboral" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Siguiente</span>
                    </button>
                </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 px-0">
                <div class="position-relative h-100">
                    <div class="search-panel">
                        <app-search
                            [typeSearch]="typeSearch"
                        ></app-search>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>